/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TradingScheduleEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRADING_SCHEDULE_EVENT_ENTITY_NAME = 'ixf.hours.v1.TradingScheduleEvent';
export const ixfHoursV1TradingScheduleEventEntity = new schema.Entity<IxfHoursV1TradingScheduleEvent>(IXF_HOURS_V1_TRADING_SCHEDULE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1TradingScheduleEvent) => `${entity.metadata?.eventId}` });

